//View Keys
export default {
    realtimemaps_unit_selection_unit: 'Unidad',
    realtimemaps_unit_selection_address: 'Dirección',
    realtimemaps_unit_selection_driver: 'Conductor',
    realtimemaps_unit_selection_event: 'Evento',
    realtimemaps_unit_selection_unitDate: 'Fecha de la unidad',
    realtimemaps_unit_selection_exportOfUnits: 'Unidades',
    realtimemaps_unit_selection_messageTable: 'Con el cursor, dibuje una forma en el mapa alrededor de las unidades de las que quiera ver detalles.',
};